import { getIn } from "formik";

const errorsForField = (form, fieldName, { requireTouched } = { requireTouched: true }) => (
  (
    (!requireTouched || getIn(form.touched, fieldName)) && getIn(form.errors, fieldName)
  ) || getIn(form.status, fieldName)
);

export default errorsForField;
